import React from 'react'
import '../css/provider.info.css';
import { useSolution } from '../../../contexts/SolutionsContext';

const ProviderInfo = ({ activeSolutionData }) => {

    return (
        <>
            <div className="provider-info-container" >
                <div className="row">
                    <div className="col-md-12">
                        <h3 className="provider-info-title">
                            Provider Info
                        </h3>
                    </div>
                </div>
                <div className="row ">
                    <div className="col-md-12">
                        <div className="provider-details">
                            <div className="provider-detail-row mb-3">
                                <div className="col-md-3">
                                    <span className="detail-label">Provider</span>
                                </div>
                                <div className="col-md-9">
                                    <span className="detail-value">{activeSolutionData?.solution_metadata?.a2a?.provider || 'N/A'}</span>
                                </div>
                            </div>
                            <div className="provider-detail-row">
                                <div className="col-md-3">
                                    <span className="detail-label">Documentation URL</span>
                                </div>
                                <div className="col-md-9">
                                    <span className="detail-value">
                                        {activeSolutionData?.solution_metadata?.a2a?.documentationUrl ? (
                                            <a
                                                href={activeSolutionData?.solution_metadata?.a2a?.documentationUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="documentation-link"
                                            >
                                                {activeSolutionData?.solution_metadata?.a2a?.documentationUrl}
                                            </a>
                                        ) : (
                                            <a
                                                href={activeSolutionData?.solution_metadata?.a2a?.documentationUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="documentation-link"
                                            >
                                                {activeSolutionData?.solution_metadata?.a2a?.documentationUrl}
                                            </a>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProviderInfo